<template>
    <b-modal id="shopware_manager_modal">
        <template slot="modal-title">Manage Shopware 5.6 connection</template>
        <b-form ref="shopware_manager_modal_form" v-if="project_data.connections.indexOf('Shopware') === -1">
            <b-form-group label="Webshop URL">
                <b-form-input
                        id="webshop_url"
                        :state="validateWebshopUrl"
                        v-model="shopware_credentials.webshop_url"
                        required/>
                <b-form-invalid-feedback :state="validateWebshopUrl">
                    Webshop URL is required.
                </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label="API User">
                <b-form-input
                        id="api_user"
                        :state="validateApiUser"
                        v-model="shopware_credentials.api_user"
                        required/>
                <b-form-invalid-feedback :state="validateApiUser">
                    API User is required.
                </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label="API Key">
                <b-form-input
                        id="api_key"
                        :state="validateApiKey"
                        v-model="shopware_credentials.api_key"
                        required/>
                <b-form-invalid-feedback :state="validateApiKey">
                    API Key is required.
                </b-form-invalid-feedback>
            </b-form-group>
            <hr/>
            <b-button block
                      variant="primary"
                      :disabled="authorizing"
                      @click="authorize">
                Authorize
            </b-button>
        </b-form>
        <div v-if="project_data.connections.indexOf('Shopware') >= 0">
            <b-button block
                      variant="danger"
                      :disabled="clearing_credentials"
                      @click="clearCredentials">
                Clear credentials
            </b-button>
        </div>
    </b-modal>
</template>
<script>
    import ShopwareConnectionService from '../../../services/ShopwareConnectionService';

    export default {
        props: {
            project_data: {
                type: Object,
                default: () => {
                }
            }
        },
        data() {
            return {
                shopware_credentials: {
                    webshop_url: '',
                    api_user: '',
                    api_key: ''
                },
                authorizing: false,
                clearing_credentials: false
            }
        },
        methods: {
            checkFields() {
                if (this.shopware_credentials.webshop_url.length <= 0) return false;
                if (this.shopware_credentials.api_user.length <= 0) return false;
                if (this.shopware_credentials.api_key.length <= 0) return false;
                return true;
            },
            authorize(modal) {
                if (this.$refs.shopware_manager_modal_form.checkValidity() && this.checkFields()) {
                    let self = this;
                    const body = Object.assign(
                        {project_id: this.project_data.project_id},
                        this.shopware_credentials
                    );
                    this.authorizing = true;

                    ShopwareConnectionService.authorize(body).then(res => {
                        if (res.data.success) {
                            self.shopware_credentials.webshop_url = '';
                            self.shopware_credentials.api_user = '';
                            self.shopware_credentials.api_key = '';
                            self.$emit('shopware-authorization-complete', this.project_data.project_id);
                        }
                        this.authorizing = false;
                    });
                } else {
                    modal.preventDefault();
                }
            },
            clearCredentials() {
                this.clearing_credentials = true;

                ShopwareConnectionService.clearCredentials(this.project_data.project_id).then(res => {
                    if (res.data.success) {
                        this.project_data.connections = this.project_data.connections.filter(p => p !== 'Shopware');
                    }

                    this.clearing_credentials = false;
                });
            }
        },
        computed: {
            validateWebshopUrl() {
                return this.shopware_credentials.webshop_url.length > 0;
            },
            validateApiUser() {
                return this.shopware_credentials.api_user.length > 0;
            },
            validateApiKey() {
                return this.shopware_credentials.api_key.length > 0;
            }
        }
    }
</script>
